class FilterDTO
	constructor: ({
		searchConfiguration = null,
		@query = null,
		# Total count of items
		@count = null,
		# Current page items count
		@itemsCount = null,
		@pageSize = 25,
		@page = 1,
		@sortProperty = null,
		@sortDirection = 'DESC'
	}) ->
		@sortDirection = @sortDirection.toUpperCase()
		@searchConfiguration = angular.copy(searchConfiguration)

		if @query? && !@query instanceof Query
			throw new Error("Parameter 'query' must be NULL or instance of Query, #{typeof @query} provided")

	getQuery: ->
		if @query?
			query = angular.copy @query
		else
			query = new Query()

		if @sortProperty
			query.sortBy(@sortProperty, @sortDirection)

		if @pageSize > 0
			query.setPagination((@page - 1) * @pageSize, @pageSize)

		return query

	getFilter: ->
		if !@searchConfiguration?
			return {}

		filter = {}

		for key, data of @searchConfiguration
			filter[key] = data.value

		return filter

	setFilterValue: (filter, value) ->
		if !@searchConfiguration?
			return

		for configuration in @searchConfiguration
			if configuration.filters[filter]
				configuration.filters[filter].value = value
